import { Alert } from "@mui/material"
import { ActivityOpen } from "event-definitions"
import { InfoButton } from "lib/@components/colored-buttons/info-button"
import { Feature } from "lib/@components/feature"
import { If } from "lib/@components/switch"
import { FEATURE_FLAG_REGIME_AUDITING } from "routes/regime/plugins/regime-auditing/server/feature-flag-regime-auditing.mjs"
import { PublishingStepsBelow } from "slot-definitions"

PublishingStepsBelow.plug(
    <If field="activeStep.props.id" equals="Review">
        <Feature feature={FEATURE_FLAG_REGIME_AUDITING}>
            <RevisionSummaryBanner />
        </Feature>
    </If>
)

function RevisionSummaryBanner() {
    return (
        <Alert
            severity="info"
            sx={{ my: 1 }}
            data-cy="revision-summary-alert"
            action={
                <InfoButton
                    size="small"
                    sx={{ marginRight: 1 }}
                    text="Activity Log"
                    onClick={handleClick}
                    data-cy="revision-summary-activity-button"
                />
            }
        >
            Revision summary can be seen in the activity log.
        </Alert>
    )

    function handleClick() {
        ActivityOpen.raise()
    }
}
